const ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

/** crypto.getRandomValues güvenli olmayan (http) bağlamlarda da çalışır; randomUUID çalışmaz. */
export function randomId(length = 16, alphabet = ALPHABET): string {
  const bytes = new Uint8Array(length);
  globalThis.crypto.getRandomValues(bytes);
  let out = '';
  for (let i = 0; i < length; i++) out += alphabet[bytes[i] % alphabet.length];
  return out;
}
